/**
 * Kayıtlar read model (GET /log, v0.1.14): the audit chain as Turkish sentences. Read only;
 * the server builds every title, the panel never sees raw detail.
 */

import type { Instant } from './types.js';

export const LOG_KINDS = ['onay', 'gorev', 'baglanti', 'giris', 'sistem', 'ajan', 'veri', 'diger'] as const;
export type LogKind = (typeof LOG_KINDS)[number];

export const LOG_KIND_LABELS: Readonly<Record<LogKind, string>> = Object.freeze({
  onay: 'Onay',
  gorev: 'Görev',
  baglanti: 'Bağlantı',
  giris: 'Giriş',
  sistem: 'Sistem',
  ajan: 'Ajan',
  veri: 'Veri',
  diger: 'Diğer',
});

export type LogResult = 'ok' | 'denied' | 'error' | 'dry_run' | 'blocked';

export const LOG_RESULT_LABELS: Readonly<Record<LogResult, string>> = Object.freeze({
  ok: 'tamam',
  denied: 'reddedildi',
  error: 'hata',
  dry_run: 'deneme',
  blocked: 'engellendi',
});

export interface LogEvent {
  id: string;
  at: Instant;
  kind: LogKind;
  actorType: 'human' | 'agent' | 'service' | 'system';
  actor: string;
  title: string;
  detail: string | null;
  result: LogResult;
  approvalId: string | null;
  taskId: string | null;
}

export interface LogView {
  asOf: Instant;
  events: LogEvent[];
  newestAt: Instant | null;
  /** The page is full: older events exist beyond the limit. */
  hasMore: boolean;
}

export interface LogQuery {
  /** Only events after this instant (epoch ms). */
  since?: number;
  limit?: number;
}
